import AccordionToggle from './accordion-toggle';

export default AccordionToggle;